import React from 'react';
import './Startupanledbulb.css';
import Startup from '../../../imgs/Startupan1.webp';
import Startu from '../../../imgs/Startupan2.webp';


const Startupanledbulb = () => {
    return (
        <div className="Startupanle-container">
            <div className='Ordinarys'>
                <h2 className="Startupanle-title">How to Start up an LED Bulb Injection Molding Production Line?</h2>
                <p className="Startupanl-date">Nov. 21, 2022</p>
                <div className="Startupanle">
                    <img src={Startup} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
                <div className="Startupanle-content">
                    <p className="Startupanle-text">You and your clients may be aware of the potential market for LED Lighting business locally or abroad.
                        When it comes to choosing the injection molding machines, questions will come to your mind…</p>
                    <p className="Startupanle-text">Which parts should injection molding machines for production?</p>
                    <p className="Startupanle-text">What material to choose?</p>
                    <p className="Startupanle-text">What injection molding machines does Powerjet offer?</p>
                </div>
                <div className="Startupanle">
                    <img src={Startu} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                </div>
            </div>
        </div>
    );
};

export default Startupanledbulb;
